import { ReactNode } from 'react';

import { ExternalLink, PageHeader, Stack } from '@cast/design-system';
import { getDocsLink } from '@cast/utils';

type Props = {
  startContent?: ReactNode;
};

export const EvictorSettingsHeader = ({ startContent }: Props) => {
  return (
    <Stack
      direction="row"
      gap={12}
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack direction="row" gap={12} alignItems="center">
        {startContent}
        <PageHeader pb={false} heading="Bin-packing" />
      </Stack>
      <ExternalLink link={getDocsLink('docs_evictor')}>
        Documentation
      </ExternalLink>
    </Stack>
  );
};
